module.exports = __webpack_public_path__ + "static/img/9.b3d37215.jpeg";